<form [formGroup]="filterFormGroup">
    <h3 mat-dialog-title>Filter Data</h3>
    <div mat-dialog-content>
        <mat-card  appearance="outlined" style="margin-bottom:5px;">
            <mat-label>Ignore Faults Less Than (Seconds)</mat-label>
            <div>
                <mat-form-field [style.width.px]="100">
                    <input matInput cdkTextareaAutosize type="number" size="1" min="0" formControlName="MinDuration">
                </mat-form-field>
            </div>
        </mat-card>

        <mat-card  appearance="outlined" style="margin-bottom:5px;">
            <mat-radio-group aria-label="Select Type" formControlName="ValueFilterType">
                <mat-radio-button value="all">Show All</mat-radio-button>
                <mat-radio-button value="include">Include</mat-radio-button>
                <mat-radio-button value="exclude">Exclude</mat-radio-button>
            </mat-radio-group>

            <div>
                <mat-form-field class="exclude-box">
                    <mat-select  formControlName="ValueFilters" multiple panelClass="custom-size-select-panel-250px custom-size-select-panel">
                        <mat-option *ngFor="let item of formattedData" [value]="item.label">{{item.label}}</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </mat-card>

    </div>

<div mat-dialog-actions class="fx-row-end-center">
    <button mat-raised-button color="primary" (click)="filter()" [disabled]="filterFormGroup.invalid">Filter</button>
    <button mat-raised-button *ngIf="existingFilters" (click)="clearFilters()">Clear Filter(s)</button>
    <button mat-raised-button *ngIf="!existingFilters" (click)="cancel()">Cancel</button>
</div>
</form>